import { UpdatingElement } from 'lit-element';
import { addDocStyle } from '../../common/style';

export default class KiStack extends UpdatingElement {
  // language=CSS
  static styles = `
    ki-stack {
      display: block;
      position: relative;
      overflow: hidden;
    }

    ki-stack>*[key]{
      position: absolute;
      top:0;
      left: 0;
      display: none;
      height: 100%;
      width: 100%;
    }

    ki-stack>.selected{
      display: block;
    }

  `;

  static get properties() {
    return {
      selected: { type: String },
    };
  }

  constructor() {
    super();
    this.selected = this.children[0].getAttribute('key');
    this.history = [];
  }

  connectedCallback() {
    addDocStyle({ content: KiStack.styles, target: this });
    super.connectedCallback();
  }

  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has('selected')) {
      this._select(this.selected);
    }
  }

  /* @private
   * */
  _select(key) {
    let selectedChild;
    for (let c of this.children) {
      const s = c.getAttribute('key') === key;
      c.classList.toggle('selected', s);
      if (s) {
        selectedChild = c;
      }
    }
    if (!selectedChild) {
      return;
    }
    if (!selectedChild.getAttribute('skipHistory')) {
      this.history.push(key);
    }
    if (selectedChild.onShow) {
      selectedChild.onShow(); // TODO need consider
    }
  }

  back() {
    this.selected = this.history.pop();
  }
}

customElements.define('ki-stack', KiStack);
